module.exports = __webpack_public_path__ + "img/superior-safety-and-ergonomics.92b4e5a0.jpg";